import React, { useState } from 'react';
import { ChargerSidebar } from '../../components/charger_planning/ChargerSidebar';

function ChargerTableView() {

    const [collapsed, setCollapsed] = useState(false);

    const toggleCollapse = () => {
        setCollapsed(!collapsed);
    };

    return (
        <div className="flex min-h-screen">
            <ChargerSidebar collapsed={collapsed} toggleCollapse={toggleCollapse} />
            <main className={`flex-1 bg-gray-50 font-nunito ${collapsed ? "ml-[80px]" : "ml-[270px]"}`}>
                <div className="p-4 sm:p-6 lg:p-8 max-w-7xl mx-auto">
                    <h1>Charger Table View</h1>
                </div>
            </main>
        </div>
    );
}

export default ChargerTableView;